import React from 'react';
import { Helmet } from 'react-helmet-async';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OpenGraphMeta = _ref => {
  let {
    canonicalUrl,
    description,
    image,
    title
  } = _ref;
  return /*#__PURE__*/_jsxs(Helmet, {
    prioritizeSeoTags: true,
    children: [/*#__PURE__*/_jsx("meta", {
      property: "og:site_name",
      content: "Atlassian Marketplace"
    }), /*#__PURE__*/_jsx("meta", {
      property: "og:type",
      content: "website"
    }), description ? /*#__PURE__*/_jsx("meta", {
      property: "og:description",
      content: description
    }) : null, image ? /*#__PURE__*/_jsx("meta", {
      property: "og:image",
      content: image
    }) : null, title ? /*#__PURE__*/_jsx("meta", {
      property: "og:title",
      content: title
    }) : null, canonicalUrl ? /*#__PURE__*/_jsx("meta", {
      property: "og:url",
      content: canonicalUrl
    }) : null]
  });
};
export default OpenGraphMeta;